import React from "react";
import PropTypes from "prop-types";
import {
  Card,
  Divider,
  Typography,
  Table,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  Paper,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";

function CardFinanzas({ proceso, finanzas }) {
  console.log("Proceso en Finanzas:", proceso);
  // Agrupar por tipo de finanza
  const ingresos = Array.isArray(finanzas?.finanzas)
    ? finanzas.finanzas.filter((finanza) => finanza.tipo_finanza === "INGRESO")
    : [];
  const gastos = Array.isArray(finanzas?.finanzas)
    ? finanzas.finanzas.filter((finanza) => finanza.tipo_finanza === "GASTO")
    : [];
  const totalIngresos = ingresos.reduce(
    (total, finanza) => total + (Number(finanza.valor) || 0),
    0
  );
  const totalGastos = gastos.reduce((total, finanza) => total + (Number(finanza.valor) || 0), 0);
  const balance = totalIngresos - totalGastos;

  const formatCurrency = (value) => {
    //alert("value: " + JSON.stringify(value));
    //const number = value.replace(/\D/g, "");
    const number = value ? value.replace(/\D/g, "") : "0";
    //alert("number: " + JSON.stringify(number));
    const numberValue = Number(number);
    const formatter = new Intl.NumberFormat("es-CO", {
      style: "currency",
      currency: "COP",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
    return {
      formatted: formatter.format(number || 0).replace(/\s/g, ""),
      value: numberValue,
    };
  };

  return (
    <Card
      sx={{ width: "100%", height: "100%", display: "flex", flexDirection: "column", padding: 2 }}
    >
      <SuiBox p={1.5} display="flex" flexDirection="column" height="100%">
        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
          <Grid size={3}>
            <SuiTypography variant="h4">Balance</SuiTypography>
          </Grid>
          <Grid size={9}>
            <SuiTypography variant="h4">
              <Typography fontWeight="bold" color={balance >= 0 ? "green" : "red"}>
                {balance?.toLocaleString("es-CO", {
                  style: "currency",
                  currency: "COP",
                })}
              </Typography>
            </SuiTypography>
          </Grid>
        </Grid>
        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
          <Grid size={3}>
            <Typography variant="h5">Ingresos</Typography>
          </Grid>
          <Grid size={3}>
            <Typography fontWeight="bold" color="green">
              {totalIngresos?.toLocaleString("es-CO", {
                style: "currency",
                currency: "COP",
              })}
            </Typography>
          </Grid>
          <Grid size={3}>
            <Typography variant="h5">Gastos</Typography>
          </Grid>
          <Grid size={3}>
            <Typography fontWeight="bold" color="red">
              {totalGastos?.toLocaleString("es-CO", {
                style: "currency",
                currency: "COP",
              })}
            </Typography>
          </Grid>
        </Grid>
        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
          <Grid size={6}>
            {ingresos.length > 0 ? (
              <TableContainer component={Paper}>
                <Table size="small">
                  <TableBody>
                    {ingresos.map((finanza) => (
                      <TableRow key={finanza.id}>
                        <TableCell sx={{ padding: "4px 8px" }}>{finanza.tipo_ingreso}</TableCell>
                        <TableCell sx={{ padding: "4px 8px" }}>
                          {formatCurrency(String(finanza.valor)).formatted}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            ) : (
              <Typography>No hay Ingresos registrados.</Typography>
            )}
          </Grid>
          <Grid size={6}>
            {gastos.length > 0 ? (
              <TableContainer component={Paper}>
                <Table size="small">
                  <TableBody>
                    {gastos.map((finanza) => (
                      <TableRow key={finanza.id}>
                        <TableCell sx={{ padding: "4px 8px" }}>{finanza.tipo_gasto}</TableCell>
                        <TableCell sx={{ padding: "4px 8px" }}>
                          {formatCurrency(String(finanza.valor)).formatted}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            ) : (
              <Typography>No hay Gastos de Subsistencia registrados.</Typography>
            )}
          </Grid>
        </Grid>
        <Divider sx={{ my: 1 }} />
        <Grid container spacing={2}>
          {/* Propuestas de Pago */}
          <Grid item xs={12}>
            {/* <Typography variant="h5">
              Propuestas de Pago del {finanzas.propuestaPago[0]?.fecha_inicio} (
              {finanzas.propuestaPago[0]?.activa ? "Activa" : "Inactiva"})
            </Typography> */}
            <Typography variant="h5">
              Propuestas de Pago desde el{" "}
              {Array.isArray(finanzas?.propuestaPago) && finanzas.propuestaPago.length > 0 ? (
                <>
                  {new Date(finanzas.propuestaPago[0].fecha_inicio).toLocaleDateString("es-CO", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                  })}{" "}
                  ({finanzas.propuestaPago[0].activa ? "Activa" : "Inactiva"})
                </>
              ) : (
                "Sin fecha"
              )}
            </Typography>
            <Divider sx={{ my: 1 }} />
            <Typography>
              {Array.isArray(finanzas?.propuestaPago) && finanzas.propuestaPago.length > 0
                ? finanzas.propuestaPago[0].descripcion_general || "No especificado"
                : "No especificado"}
            </Typography>
          </Grid>
        </Grid>
      </SuiBox>
    </Card>
  );
}

CardFinanzas.propTypes = {
  proceso: PropTypes.object.isRequired,
  finanzas: PropTypes.shape({
    finanzas: PropTypes.array,
    propuestaPago: PropTypes.array,
  }).isRequired,
};

export default CardFinanzas;
